import React, { useEffect, useState } from "react";
import Header from "units/dashboard/components/Header";
import { SidebarProvider } from "units/dashboard/context/SidebarProvider";
import UserSidebar from "../components/UserSidebar";
import { ProgressBar } from "react-loader-spinner";
import Footer from "units/dashboard/components/Footer";
import Plans from "./plans/Plans";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function PlanSelector() {
  const { t } = useTranslation(["user"]);

  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);

  const searchRegex = /^[\u0600-\u06FF0-9\s]+$/;

  const filteredPlans = plans.filter((plan) =>
    plan.name?.toLowerCase().includes(searchInput.toLowerCase())
  );

  const searchInputHandler = (e) => {
    const value = e.target.value;
    if (value === "" || searchRegex.test(value)) {
      setSearchInput(value);
    }
  };

  return (
    <>
      <SidebarProvider>
        {/* Header */}
        <nav className="fixed top-0 right-0 left-0 z-[100] border-b border-slate-100 bg-white dark:bg-zinc-800 dark:border-zinc-700">
          <Header />
        </nav>

        {/* Sidebar */}
        <div className="vertical-menu fixed rtl:right-0 ltr:left-0 bottom-0 top-16 h-screen z-[100] border-r bg-slate-50 border-gray-50 dark:bg-zinc-800 dark:border-neutral-700">
          <UserSidebar />
        </div>
      </SidebarProvider>

      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <ProgressBar
            visible={true}
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <div className="flex flex-col min-h-screen mt-4">
          <div className="main-content flex-grow pt-16 pb-12">
            <div className="container-fluid px-[0.625rem] mt-10 flex justify-between items-center relative z-20">
              <div>
                <div className="grid grid-cols-1 mb-2">
                  <div className="flex items-center justify-between">
                    <h4 className="mb-sm-0 text-xl font-bold grow 
                                   text-black dark:!text-teal-300">
                      {t("planSelector.pageTitle")}
                    </h4>
                    <nav className="flex" aria-label={t("planSelector.breadcrumb")}></nav>
                  </div>
                </div>
                <h1 className="text-md mr-2 
                               text-gray-800 dark:!text-teal-100">
                  {" "}
                  {t("planSelector.pageSubtitle")}
                </h1>
              </div>

              {/* جستجو */}
              <div className="pl-3 relative z-20">
                <input
                  value={searchInput}
                  type="text"
                  onChange={searchInputHandler}
                  className="h-10 w-[8rem] sm:!w-[15rem] p-3 pr-10
                             rounded-md 
                             bg-teal-50 dark:bg-teal-950
                             border-2 border-teal-300 dark:!border-teal-600
                             text-black dark:!text-white
                             placeholder:text-gray-700 dark:placeholder:!text-teal-100
                             text-sm
                             focus:outline-none 
                             focus:ring-2 focus:ring-teal-400 dark:focus:!ring-teal-300
                             focus:border-teal-500 dark:focus:!border-teal-300
                             transition-all duration-300"
                  placeholder={t("planSelector.searchPlaceholder")}
                />
                <FaSearch className="absolute end-5 top-1/2 -translate-y-1/2 
                                     text-teal-700 dark:!text-white" />
              </div>
            </div>

            <Plans plans={filteredPlans} setPlans={setPlans} />

            <Footer />
          </div>
        </div>
      )}
    </>
  );
}